import React, { useCallback } from 'react'
import { SubmissionError } from 'redux-form'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import QS from 'qs'

import { getCurrentOrganizationId } from '../../../ducks/users'
import { createDatabase } from '../../../ducks/databases'

import Form from './Form'

const INITIAL_VALUES = {
  type: 'postgres',
}

export const FormWrapper = function DatabaseSetupFormWrapper({
  onSuccess,
  title,
  subtitle,
  initialValues,
  hideType,
  onCancel,
  cancelButtonText,
}) {
  const dispatch = useDispatch()
  const orgId = useSelector(getCurrentOrganizationId)

  const handleSubmit = useCallback(
    async data => {
      try {
        let result = await dispatch(createDatabase(orgId, data))

        if (onSuccess) {
          onSuccess(result.value.data)
        }
      } catch (err) {
        if (err.response && err.response.data && err.response.data.error) {
          throw new SubmissionError({
            _error: err.response.data.error,
          })
        }

        throw new SubmissionError({
          _error: `We couldn’t connect to the database.
           Please double-check the connection details and try again.`,
        })
      }
    },
    [dispatch]
  )

  return (
    <Form
      hideType={hideType}
      onSubmit={handleSubmit}
      initialValues={initialValues || INITIAL_VALUES}
      title={title}
      subtitle={subtitle}
      onCancel={onCancel}
      cancelButtonText={cancelButtonText}
    />
  )
}

export default function DatabaseSetup() {
  const history = useHistory()

  const handleSuccess = useCallback(() => {
    let { redirect } = QS.parse(window.location.search, {
      ignoreQueryPrefix: true,
    })

    if (!redirect) {
      redirect = '/'
    }

    history.push(redirect)
  }, [history])

  return <FormWrapper onSuccess={handleSuccess} title="Setup New Source" />
}
